import { ref, computed, watch } from "vue";
import { resetCallForm } from "./useCallForm";

const STORAGE_KEY = "callMinimized";

function readInitialMinimized() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === null) return true;
  return stored === "true";
}

const callActive = ref(false);
const callMinimized = ref(readInitialMinimized());
const callTargetOperatorId = ref(null);
const callQueueType = ref(null);
const callRequestId = ref(null);
const callFormSubmitted = ref(false);
const callHidden = ref(false);

const callPhase = computed(() => (callFormSubmitted.value ? "iframe" : "form"));

watch(callMinimized, (value) => {
  localStorage.setItem(STORAGE_KEY, value ? "true" : "false");
});

function openCall() {
  if (callActive.value) return;
  callTargetOperatorId.value = null;
  callQueueType.value = null;
  callRequestId.value = null;
  callFormSubmitted.value = false;
  callHidden.value = false;
  callActive.value = true;
}

function closeCall() {
  callActive.value = false;
  callTargetOperatorId.value = null;
  callQueueType.value = null;
  callRequestId.value = null;
  callFormSubmitted.value = false;
  callHidden.value = false;
  resetCallForm();
}

function setCallSession({ targetOperatorId, queueType, requestId }) {
  callTargetOperatorId.value = targetOperatorId || null;
  callQueueType.value = queueType || null;
  callRequestId.value = requestId || null;
  callFormSubmitted.value = true;
}

export function useCallWindow() {
  return {
    callActive,
    callMinimized,
    callHidden,
    callTargetOperatorId,
    callQueueType,
    callRequestId,
    callPhase,
    openCall,
    closeCall,
    setCallSession,
  };
}
